<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <popup-header @clickClose="closeModalCustom()" :headerBg="'grey'" />
    <v-container class="bg-grey app-wrapper overflow-y-auto">
      <v-row>
        <v-col cols="12" class="pt-0 px-6" style="padding-bottom: 68px">
          <!-- 신청서 시작 -->
          <v-card
            class="mx-auto card-box"
            elevation="0"
            v-show="!GET_APP_LOADING_STATUS"
          >
            <!-- 신청서 head -->
            <v-row
              class="ma-0 card-header"
              justify="space-between"
              :class="isCancel ? 'cancel' : ''"
            >
              <v-col class="pa-0 text-center" cols="12">
                <!-- 취소 신청서 -->
                <v-avatar size="62" color="#757a81" v-if="isCancel">
                  <icon-application-cancel :width="30" :height="30" />
                </v-avatar>

                <!-- 일반 신청서 -->
                <v-avatar size="62" color="#E9F9EE" v-else>
                  <icon-approval-doc :width="30" :height="30" />
                </v-avatar>
              </v-col>
              <v-col
                cols="12"
                class="pa-0 text-center pt-5 notice"
                v-html="confirmTitle"
              />
            </v-row>

            <!-- 신청서 내용 -->
            <v-list class="card-contents" v-show="!GET_APP_LOADING_STATUS">

              <!-- 독감예방접종 -->
              <vaccination-viewer-data
                v-if="isVaccation"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 학자금 -->
              <edus-app-viewer-data
                v-if="isEdusApp"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직, 가족돌봄휴직) -->
              <lea-abs-par-fam-viewer-data
                v-if="isLeaAbsParental || isLeaAbsFamily"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(난임치료휴직, 공상휴직, 사상휴직, 신상휴직) -->
              <lea-abs-etc-viewer-data
                v-if="
                  isLeaAbsInfertility ||
                  isLeaAbsSick ||
                  isLeaAbsCasualty ||
                  isLeaAbsNew ||
                  isLeaEaAbsExtension
                "
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(복직신청) -->
              <lea-abs-rch-viewer-data
                v-if="isLeaAbsApplication"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직 연장신청) -->
              <lea-abs-par-leave-viewer-data
                v-if="isLeaAbsExtension"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직 추가신청) -->
              <lea-abs-par-leave-add-viewer-data
                v-if="isLeaAbsAdd"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴일근무사전대체신청 -->
              <hol-replace-viewer-data
                v-if="isHolReplace"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴일근무사전대체취소신청 -->
              <hol-replace-cancel-viewer-data
                v-if="isHolReplaceCancel"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 재직증명 신청 -->
              <re-cert-tenure-viewer-data
                v-if="isReCertTenure || isReCertTenureEng"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 원천징수 신청 -->
              <re-cert-tax-viewer-data
                v-if="isReCertTax1 || isReCertTax2"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 휴직증명서 신청 -->
              <re-cert-leave-viewer-data
                v-if="isReCertLeave"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 갑근세 증명원 신청 -->
              <re-cert-gab-tax-viewer-data
                v-if="isReCertGabTax"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 시차출퇴근 신청 -->
              <work-schedule-time-viewer-data
                v-if="isWorkScheduleTime"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 근태/휴가 신청 -->
              <vacations-viewer-data
                v-if="isVaction"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 근태/휴가 취소 신청 -->
              <vacations-cancel-viewer-data
                v-if="isVacationCancel"
                :appInfoParam="appInfoParam"
                @showFileView="showFileView"
              />
              <!-- 연장근무신청 -->
              <ot-work-viewer-data
                v-if="isOtWork"
                :appInfoParam="appInfoParam"
              />
              <!-- 근무스케줄신청 -->
              <schedule-viewer-data
                v-if="isSchedule"
                :appInfoParam="appInfoParam"
              />

              <!-- 출퇴근변경신청 -->
              <attend-viewer-data
                v-if="isAttend"
                :appInfoParam="appInfoParam"
              />
            </v-list>
          </v-card>
          <!-- 신청서 그외 정보 -->
          <v-expansion-panels
            v-model="panelArray"
            multiple
            v-show="!GET_APP_LOADING_STATUS"
          >
            <appl-panel>
              <span slot="title">결재자</span>
              <appl-line slot="component" />
            </appl-panel>
            <appl-panel v-show="fileViewShow">
              <span slot="title">첨부파일</span>
              <!-- <attach-file slot="component" /> -->
              <bgf-attach-file-view slot="component" />
            </appl-panel>
            <!-- <appl-panel>
              <span slot="title">참조자</span>
              <refer-line slot="component" />
            </appl-panel>
            -->
            <appl-panel>
              <span slot="title">담당자</span>
              <mgr-line slot="component" />
            </appl-panel>
          </v-expansion-panels>

          <!-- 신청서 뷰어 스켈레톤 로더 -->
          <viewer-skeleton-loader v-show="GET_APP_LOADING_STATUS" />
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>
<script>
import PopupHeader from '@/components/common/PopupHeader.vue';
import VacationViewerData from '@/components/application/viewer/VacationViewerData.vue';
import VaccinationViewerData from '@/components/application/viewer/VaccinationViewerData.vue';
import EdusAppViewerData from '@/components/application/viewer/EdusAppViewerData.vue';
import LeaAbsParFamViewerData from '@/components/application/viewer/LeaAbsParFamViewerData';
import LeaAbsEtcViewerData from '@/components/application/viewer/LeaAbsEtcViewerData';
import LeaAbsRchViewerData from '@/components/application/viewer/LeaAbsRchViewerData';
import LeaAbsParLeaveViewerData from '@/components/application/viewer/LeaAbsParLeaveViewerData';
import LeaAbsParLeaveAddViewerData from '@/components/application/viewer/LeaAbsParLeaveAddViewerData';
import HolReplaceViewerData from '@/components/application/viewer/HolReplaceViewerData.vue';
import HolReplaceCancelViewerData from '@/components/application/viewer/HolReplaceCancelViewerData.vue';
import ReCertTenureViewerData from '@/components/application/viewer/ReCertTenureViewerData.vue';
import ReCertTaxViewerData from '@/components/application/viewer/ReCertTaxViewerData.vue';
import ReCertLeaveViewerData from '@/components/application/viewer/ReCertLeaveViewerData.vue';
import ReCertGabTaxViewerData from '@/components/application/viewer/ReCertGabTaxViewerData.vue';
import WorkScheduleTimeViewerData from '@/components/application/viewer/WorkScheduleTimeViewerData.vue';
import VacationsViewerData from '@/components/application/viewer/VacationsViewerData.vue';
import VacationsCancelViewerData from '@/components/application/viewer/VacationsCancelViewerData.vue';

import OtWorkViewerData from '@/components/application/viewer/OtWorkViewerData.vue';
import ScheduleViewerData from '@/components/application/viewer/ScheduleViewerData.vue';
import AttendViewerData from '@/components/application/viewer/AttendViewerData.vue';
//import AttachFile from '@/components/application/form/AttachFile.vue';
import ApplLine from '@/components/application/form/ApplLine.vue';
//import ReferLine from '@/components/application/form/ReferLine.vue';
import ApplPanel from '@/components/application/form/ApplPanel.vue';
import ViewerSkeletonLoader from '@/components/application/viewer/ViewerSkeletonLoader.vue';

import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue';
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue';
import { mapGetters, mapMutations } from 'vuex';
import viewerMixin from '@/mixins/viewerMixin.js';
import dialogMixin from '@/mixins/dialogMixin.js';
import routerNames from '@/const/routerConstants';

import MgrLine from '@/components/application/form/MgrLine.vue';
import BgfAttachFileView from '@/components/application/form/BgfAttachFileView.vue';

export default {
  mixins: [viewerMixin, dialogMixin],
  data: () => ({
    appViewData: [],
    modalName: 'application_confirm',
    fileSeq: 0,
    fileViewShow: true,
  }),
  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_APPL_CD', 'GET_FILE_SEQ']),
    ...mapGetters('ELA', [
      'GET_ELA_APPL_PARAM',
      'GET_SEARCH_APPL_CD',
      'GET_SEARCH_APPL_SEQ',
      //'GET_FILE_LIST',
      //'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
    ]),
    ...mapGetters('CODE', ['GET_GNT_CD_NM']),

    isCancel() {
      return this.isCancelVacation || this.isCancelReward;
    },

    searchApplSabun() {
      return this.GET_ELA_APPL_PARAM.searchApplSabun;
    },
    panelArray() {
      let panel = [0];

      if (this.GET_FILE_SEQ !== 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.fileSeq = this.GET_FILE_SEQ;
      }
      if (this.fileSeq > 0) panel.push(1);
      if (this.GET_MGR_USER_LIST.length > 0) panel.push(2);
      /*
      if (this.GET_FILE_LIST.length > 0) {
        panel.push(1);
      }
      //if (this.GET_REFER_USER_LIST.length > 0) {panel.push(2);}
      if (this.GET_MGR_USER_LIST.length > 0) {
        panel.push(2);
      }
      */
      return panel;
    },
    appInfoParam() {
      return {
        viewerType: 'applConfirm',
        applCd: this.GET_SEARCH_APPL_CD,
        applSeq: this.GET_SEARCH_APPL_SEQ,
        applSabun: this.GET_USER_DATA.ssnSabun,
      };
    },
  },
  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP', 'SET_GNT_GUBUN_TMP']),

    // 신청 상세 기본 정보 조회
    async fetchApplInfo() {
      const initParams = {
        searchApplCd: this.GET_SEARCH_APPL_CD, // 근태
        adminYn: 'N',
        authPg: 'R',
        searchApplSeq: this.GET_SEARCH_APPL_SEQ,
        searchApplSabun: this.GET_USER_DATA.ssnSabun,
        searchApplInSabun: this.GET_USER_DATA.ssnSabun,
        searchApplStatusCd: '31', // 신청
      };

      // const initParams = {
      //   searchApplCd: 43, // 근태
      //   adminYn: 'N',
      //   authPg: 'R',
      //   searchApplSeq: '2022100611576',
      //   searchApplSabun: this.GET_USER_DATA.ssnSabun,
      //   searchApplInSabun: this.GET_USER_DATA.ssnSabun,
      //   searchApplStatusCd: '21', // 신청
      //   searchApplYmd: '20220804',
      // };

      // console.log('initParams : ' + JSON.stringify(initParams));
      try {
        //await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);
        //await this.$store.dispatch('ELA/FETCH_FILE_LIST'); 파일처리 추후에
      } catch (error) {
        alert(error);
      }
    },
    closeModalCustom() {
      this.toggleModal();
      this.$router.push(routerNames.MyBox);
    },
    /* 뒤로가기 방지 */
    handlePopstate() {
      alert('신청이 완료된 신청서입니다.');
      this.$router.push({ name: routerNames.Main, params: 'confirm' });
    },

    showFileView(flag) {
      this.fileViewShow = flag;
    }
  },

  created() {
    this.fetchApplInfo();
  },
  components: {
    PopupHeader,
    VacationViewerData,
    OtWorkViewerData,
    ScheduleViewerData,
    AttendViewerData,
    IconApprovalDoc,
    IconApplicationCancel,
    //AttachFile,
    ApplLine,
    //ReferLine,
    ApplPanel,
    ViewerSkeletonLoader,
    MgrLine,
    VaccinationViewerData,
    EdusAppViewerData,
    LeaAbsParFamViewerData,
    LeaAbsEtcViewerData,
    LeaAbsRchViewerData,
    LeaAbsParLeaveViewerData,
    LeaAbsParLeaveAddViewerData,
    BgfAttachFileView,
    HolReplaceViewerData,
    HolReplaceCancelViewerData,
    ReCertTenureViewerData,
    ReCertTaxViewerData,
    ReCertLeaveViewerData,
    ReCertGabTaxViewerData,
    WorkScheduleTimeViewerData,
    VacationsViewerData,
    VacationsCancelViewerData,
  },
};
</script>
<style>
/* application.scss 참고 */
</style>
